/* =========================================================
   Affiche MON MATÉRIEL — l'objet du sport, dessiné à ses vraies cotes.
   API : SNMtMateriel.render(data, opts) -> string SVG
     data : { mode, titre, kicker, club, lieu, joueur, equipe, l1..l5,
              mode 'ski'        → longueur (cm), cote (« 124-78-110 »), fixation
              mode 'boule'      → diametre (mm), poids (g), striage
              mode 'aviron'     → longueur (cm), pelle, couleur1, couleur2, motif }
     opts : { palette }

   LE PARTI PRIS : les proportions sont VRAIES, jamais retouchées pour remplir
   la page. Un ski fait 1,70 m de long pour 78 mm au patin — soit un rapport de
   1 à 22 — et il est dessiné ainsi. La place qui reste devient de la cotation,
   comme sur une planche de bureau d'études. Élargir le ski pour « faire joli »
   effacerait précisément ce qui se voit ici : sa finesse.

   Ce qui vient du client est ÉCHAPPÉ ou passé par une table fermée. Aucune
   valeur réglementaire n'est affirmée : ce sont les cotes de SON matériel.

   Auto-suffisant (aucun fetch, aucune image, aucun aléa) → re-render serveur.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 64;

  const PALETTES = {
    calque: { label:'Calque', bg:'#F2EFE6', ink:'#1B2A32', muted:'#7E8A8E', accent:'#C2410C', line:'#DCD6C8', card:'#FBF9F3', metal:'#C9CDD1' },
    atelier:{ label:'Atelier',bg:'#20242A', ink:'#F0F2F3', muted:'#8E979F', accent:'#E8933D', line:'#333A43', card:'#2A2F36', metal:'#9AA3AB' },
    nuit:   { label:'Nuit',   bg:'#0B2D5B', ink:'#F7F4ED', muted:'#93A1B8', accent:'#FF9E5C', line:'#1E4272', card:'#12355F', metal:'#A8B6C8' },
    terre:  { label:'Terre',  bg:'#2B2018', ink:'#F5EFE4', muted:'#B49B7E', accent:'#E8A33D', line:'#4A392A', card:'#3A2C20', metal:'#B9AFA2' },
  };

  const esc = s => String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  const up = s => String(s == null ? '' : s).toUpperCase();
  const num = s => { const m = String(s == null ? '' : s).replace(',', '.').replace(/\s/g, '').match(/-?\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; };
  const fr = n => String(n).replace('.', ',');
  const fit = (t, maxW, maxS, cwf, ls, minS) => { const n = String(t).length || 1; minS = minS || 12;
    for (let s = maxS; s > minS; s -= 1) if (n * (cwf * s + ls) <= maxW) return s; return minS; };
  const T = (x,y,size,fill,txt,o) => { o = o || {};
    return `<text x="${x}" y="${y}" font-family="${o.f||'Sora'}" font-size="${size}" font-weight="${o.w||600}" fill="${fill}"`
      + (o.ls?` letter-spacing="${o.ls}"`:'') + ` text-anchor="${o.a||'middle'}"` + (o.op?` opacity="${o.op}"`:'') + `>${txt}</text>`; };
  const cleFermee = (v, table, defaut) => {
    const k = String(v == null ? '' : v).trim().toLowerCase().replace(/[\s-]/g, '');
    return Object.prototype.hasOwnProperty.call(table, k) ? k : defaut;
  };

  /* ---------- outils de planche technique ---------- */
  /** Cote verticale : deux segments, un vide pour le texte, deux embouts. */
  function coteV(x, y0, y1, texte, p) {
    const my = (y0 + y1) / 2;
    return `<line x1="${x.toFixed(1)}" y1="${y0.toFixed(1)}" x2="${x.toFixed(1)}" y2="${(my - 24).toFixed(1)}" stroke="${p.muted}" stroke-width="1.2"/>`
      + `<line x1="${x.toFixed(1)}" y1="${(my + 24).toFixed(1)}" x2="${x.toFixed(1)}" y2="${y1.toFixed(1)}" stroke="${p.muted}" stroke-width="1.2"/>`
      + `<line x1="${(x - 7).toFixed(1)}" y1="${y0.toFixed(1)}" x2="${(x + 7).toFixed(1)}" y2="${y0.toFixed(1)}" stroke="${p.muted}" stroke-width="1.2"/>`
      + `<line x1="${(x - 7).toFixed(1)}" y1="${y1.toFixed(1)}" x2="${(x + 7).toFixed(1)}" y2="${y1.toFixed(1)}" stroke="${p.muted}" stroke-width="1.2"/>`
      + T(x, my + 7, 18, p.muted, texte, { f:'Oswald', w:700 });
  }
  /** Renvoi coté : un trait qui part de l'objet vers une étiquette. */
  function renvoi(xObjet, y, xTexte, titre, detail, p) {
    const sens = xTexte > xObjet ? 1 : -1;
    return `<line x1="${xObjet.toFixed(1)}" y1="${y.toFixed(1)}" x2="${(xTexte - sens * 10).toFixed(1)}" y2="${y.toFixed(1)}" stroke="${p.muted}" stroke-width="1.2"/>`
      + `<circle cx="${xObjet.toFixed(1)}" cy="${y.toFixed(1)}" r="2.6" fill="${p.muted}"/>`
      + T(xTexte, y + (detail ? -3 : 5), 16, p.ink, titre, { f:'Oswald', w:700, a: sens > 0 ? 'start' : 'end' })
      + (detail ? T(xTexte, y + 15, 10.5, p.muted, detail, { w:600, ls:2, a: sens > 0 ? 'start' : 'end' }) : '');
  }

  /* =================================================================
     LES OBJETS. Chacun sait se dessiner dans une boîte { cx, yHaut, H }
     et rend son propre jeu de cotes par défaut pour le bandeau du bas.
     Ajouter un sport = une entrée ici, rien d'autre.
     ================================================================= */

  /** « 124-78-110 » → [124, 78, 110]. Spatule, patin, talon, en millimètres. */
  function ligneDeCote(s) {
    const v = String(s == null ? '' : s).split(/[^0-9.,]+/).map(x => num(x)).filter(x => x != null && x > 0);
    return v.length >= 3 ? v.slice(0, 3) : [124, 78, 110];
  }

  /* LES COULEURS DE CLUB, en TABLE FERMÉE. C'est la seule couleur que le
     client choisit, et elle finit dans un attribut `fill` : une saisie libre
     ici, et n'importe qui pourrait injecter ce qu'il veut dans le SVG. Le nom
     sert de clé, jamais de valeur. */
  const COULEURS = {
    rouge: '#D64545', bleu: '#2E6DA4', marine: '#1B3A5C', ciel: '#5BA8D6', vert: '#2E9E4F',
    sapin: '#1F5B3A', jaune: '#E8C33D', orange: '#E8933D', bordeaux: '#8A2B3A', violet: '#7B5EA7',
    noir: '#1D1D1B', blanc: '#FFFFFF', gris: '#9AA3AB',
  };
  const teinte = (v, defaut) => COULEURS[cleFermee(v, COULEURS, defaut)];

  const OBJETS = {
    ski: {
      label: 'Ski',
      dessin(cx, yHaut, H, data, p) {
        const L = num(data.longueur) || 170;              /* centimètres */
        const [sp, pat, tal] = ligneDeCote(data.cote);    /* millimètres */
        const s = H / (L * 10);                           /* unités par millimètre */
        const hSp = sp / 2 * s, hPat = pat / 2 * s, hTal = tal / 2 * s;
        const yB = yHaut + H;
        /* Repères le long du ski, en fraction de la longueur. */
        const yTip = yHaut + H * 0.09, yPat = yHaut + H * 0.55, yTal = yHaut + H * 0.90;

        /* Un ski, contour symétrique. Le bord gauche reprend les mêmes points
           de contrôle que le droit, parcourus à l'envers. */
        const trace = (ax) => {
          const P = (sg, x, y) => `${(ax + sg * x).toFixed(1)} ${y.toFixed(1)}`;
          const a1 = [hSp * 0.86, yHaut + H * 0.012], a2 = [hSp, yHaut + H * 0.05], a3 = [hSp, yTip];
          const b1 = [hSp, yHaut + H * 0.30], b2 = [hPat, yHaut + H * 0.42], b3 = [hPat, yPat];
          const c1 = [hPat, yHaut + H * 0.70], c2 = [hTal, yHaut + H * 0.84], c3 = [hTal, yTal];
          let d = `M ${ax} ${yHaut.toFixed(1)}`
            + ` C ${P(1,a1[0],a1[1])} ${P(1,a2[0],a2[1])} ${P(1,a3[0],a3[1])}`
            + ` C ${P(1,b1[0],b1[1])} ${P(1,b2[0],b2[1])} ${P(1,b3[0],b3[1])}`
            + ` C ${P(1,c1[0],c1[1])} ${P(1,c2[0],c2[1])} ${P(1,c3[0],c3[1])}`
            + ` L ${P(1,hTal,yB - hTal * 0.5)}`
            + ` Q ${P(1,hTal,yB)} ${P(1,hTal*0.55,yB)}`
            + ` L ${P(-1,hTal*0.55,yB)}`
            + ` Q ${P(-1,hTal,yB)} ${P(-1,hTal,yB - hTal * 0.5)}`
            + ` L ${P(-1,c3[0],c3[1])}`
            + ` C ${P(-1,c2[0],c2[1])} ${P(-1,c1[0],c1[1])} ${P(-1,b3[0],b3[1])}`
            + ` C ${P(-1,b2[0],b2[1])} ${P(-1,b1[0],b1[1])} ${P(-1,a3[0],a3[1])}`
            + ` C ${P(-1,a2[0],a2[1])} ${P(-1,a1[0],a1[1])} ${ax} ${yHaut.toFixed(1)} Z`;
          let g = `<path d="${d}" fill="${p.card}" stroke="${p.ink}" stroke-width="2" stroke-linejoin="round"/>`;
          /* la fixation, à peu près au patin */
          g += `<rect x="${(ax - hPat * 1.15).toFixed(1)}" y="${(yPat - H * 0.055).toFixed(1)}" width="${(hPat * 2.3).toFixed(1)}" height="${(H * 0.11).toFixed(1)}" rx="4" fill="${p.ink}" opacity="0.85"/>`;
          return g;
        };
        const ecart = Math.max(26, hSp * 2.6);
        let g = trace(cx - ecart) + trace(cx + ecart);

        /* Cotation : la longueur à gauche, la ligne de cote à droite. */
        g += coteV(cx - ecart - hSp - 62, yHaut, yB, `${fr(L)} CM`, p);
        const xT = cx + ecart + hSp + 26;
        g += renvoi(cx + ecart + hSp, yTip, xT, `${sp} MM`, 'SPATULE', p)
          + renvoi(cx + ecart + hPat, yPat, xT, `${pat} MM`, 'PATIN', p)
          + renvoi(cx + ecart + hTal, yTal, xT, `${tal} MM`, 'TALON', p);
        return g;
      },
      cotes: d => { const [sp, pat, tal] = ligneDeCote(d.cote); return [
        [`${fr(num(d.longueur) || 170)} cm`, 'Longueur'], [`${sp}-${pat}-${tal}`, 'Ligne de cote'],
        [esc(String(d.fixation || '').trim()) || '—', 'Fixation']]; },
      legende: d => { const [sp, pat, tal] = ligneDeCote(d.cote);
        return `LIGNE DE COTE ${sp}-${pat}-${tal} · PROPORTIONS RÉELLES`; },
    },

    boule: {
      label: 'Boule',
      dessin(cx, yHaut, H, data, p) {
        const D = Math.max(60, Math.min(90, num(data.diametre) || 74));   /* mm, bornes du règlement */
        const R = Math.min(H, 420) / 2;
        const cy = yHaut + H / 2;
        const STRIES = { lisse: 0, simple: 5, double: 9 };
        const nS = STRIES[cleFermee(data.striage, STRIES, 'simple')];
        let g = `<circle cx="${cx}" cy="${cy.toFixed(1)}" r="${R.toFixed(1)}" fill="${p.metal}" stroke="${p.ink}" stroke-width="2.5"/>`;
        /* Les stries sont des CORDES calculées, pas un motif rogné : le rendu
           print passe par resvg, autant ne dépendre d'aucun clipPath. */
        for (let i = 1; i <= nS; i++) {
          const k = -1 + (2 * i) / (nS + 1);
          const y = cy + k * R, hw = Math.sqrt(Math.max(0, 1 - k * k)) * R * 0.985;
          g += `<line x1="${(cx - hw).toFixed(1)}" y1="${y.toFixed(1)}" x2="${(cx + hw).toFixed(1)}" y2="${y.toFixed(1)}" stroke="${p.ink}" stroke-width="${(R * 0.022).toFixed(1)}" opacity="0.45"/>`;
        }
        g += `<circle cx="${(cx - R * 0.32).toFixed(1)}" cy="${(cy - R * 0.34).toFixed(1)}" r="${(R * 0.18).toFixed(1)}" fill="#FFFFFF" opacity="0.14"/>`;
        /* la cote de diamètre, en travers de la boule */
        g += `<line x1="${(cx - R).toFixed(1)}" y1="${(cy + R + 34).toFixed(1)}" x2="${(cx + R).toFixed(1)}" y2="${(cy + R + 34).toFixed(1)}" stroke="${p.muted}" stroke-width="1.2"/>`;
        for (const x of [cx - R, cx + R])
          g += `<line x1="${x.toFixed(1)}" y1="${(cy + R + 27).toFixed(1)}" x2="${x.toFixed(1)}" y2="${(cy + R + 41).toFixed(1)}" stroke="${p.muted}" stroke-width="1.2"/>`;
        g += `<rect x="${(cx - 42).toFixed(1)}" y="${(cy + R + 22).toFixed(1)}" width="84" height="24" fill="${p.bg}"/>`
          + T(cx, cy + R + 40, 18, p.muted, `${fr(D)} MM`, { f:'Oswald', w:700 });
        return g;
      },
      cotes: d => [[`${fr(Math.max(60, Math.min(90, num(d.diametre) || 74)))} mm`, 'Diamètre'],
        [esc(String(d.poids || '').trim()) || '—', 'Poids'],
        [esc(String(d.striage || '').trim()) || '—', 'Striage']],
      legende: () => 'LE RÈGLEMENT ADMET DE 71 À 80 MM ET DE 650 À 800 G',
    },

    pelle: {
      label: 'Pelle',
      /* LA PELLE, EN GRAND. L'aviron entier mesure 2,88 m pour une pelle de
         50 cm : dessiné en entier à ses vraies proportions, il se réduit à un
         trait et la pelle devient illisible — or c'est elle le sujet, c'est
         elle qui porte les couleurs du club et c'est elle qu'un rameur
         reconnaît à deux cents mètres sur l'eau. On dessine donc la pelle à
         sa taille, le manche entrant par le haut, et la longueur totale de
         l'aviron passe en cote dans le bandeau du bas. */
      dessin(cx, yHaut, H, data, p) {
        const PELLES = { hachoir: 'Hachoir', classique: 'Classique' };
        const pelle = cleFermee(data.pelle, PELLES, 'hachoir');
        const c1 = teinte(data.couleur1, 'bleu'), c2 = teinte(data.couleur2, 'blanc');
        const MOTIFS = { uni: 'Uni', bandes: 'Bandes', diagonale: 'Diagonale', pointe: 'Pointe', chevron: 'Chevron' };
        const motif = cleFermee(data.motif, MOTIFS, 'bandes');

        /* Pelle réelle : environ 50 cm de long pour 25 de large. */
        const hP = H * 0.66, wP = hP * 0.56;
        const yP = yHaut + H * 0.26, yB = yP + hP;
        const xg = cx - wP / 2, xd = cx + wP / 2;

        /* Le manche, qui entre par le haut et disparaît dans le col. */
        const wM = Math.max(9, wP * 0.11);
        let g = `<rect x="${(cx - wM / 2).toFixed(1)}" y="${yHaut.toFixed(1)}" width="${wM.toFixed(1)}" height="${(yP - yHaut + hP * 0.10).toFixed(1)}" rx="${(wM / 2).toFixed(1)}" fill="${p.card}" stroke="${p.ink}" stroke-width="2"/>`;

        /* Le contour. Le hachoir est ASYMÉTRIQUE — c'est sa signature : bord
           supérieur court, bord inférieur long, extrémité coupée droit. Le
           classique, lui, est une feuille symétrique. */
        const d = pelle === 'hachoir'
          ? `M ${cx.toFixed(1)} ${yP.toFixed(1)}`
            + ` C ${(cx + wP * 0.30).toFixed(1)} ${(yP + hP * 0.02).toFixed(1)} ${xd.toFixed(1)} ${(yP + hP * 0.06).toFixed(1)} ${xd.toFixed(1)} ${(yP + hP * 0.16).toFixed(1)}`
            + ` L ${xd.toFixed(1)} ${(yB - hP * 0.05).toFixed(1)}`
            + ` Q ${xd.toFixed(1)} ${yB.toFixed(1)} ${(xd - wP * 0.12).toFixed(1)} ${yB.toFixed(1)}`
            + ` L ${(xg + wP * 0.08).toFixed(1)} ${(yB - hP * 0.11).toFixed(1)}`
            + ` Q ${xg.toFixed(1)} ${(yB - hP * 0.13).toFixed(1)} ${xg.toFixed(1)} ${(yB - hP * 0.22).toFixed(1)}`
            + ` L ${xg.toFixed(1)} ${(yP + hP * 0.24).toFixed(1)}`
            + ` C ${xg.toFixed(1)} ${(yP + hP * 0.06).toFixed(1)} ${(cx - wP * 0.30).toFixed(1)} ${(yP + hP * 0.02).toFixed(1)} ${cx.toFixed(1)} ${yP.toFixed(1)} Z`
          : `M ${cx.toFixed(1)} ${yP.toFixed(1)}`
            + ` C ${(cx + wP * 0.34).toFixed(1)} ${(yP + hP * 0.06).toFixed(1)} ${xd.toFixed(1)} ${(yP + hP * 0.26).toFixed(1)} ${xd.toFixed(1)} ${(yP + hP * 0.54).toFixed(1)}`
            + ` C ${xd.toFixed(1)} ${(yB - hP * 0.06).toFixed(1)} ${(cx + wP * 0.24).toFixed(1)} ${yB.toFixed(1)} ${cx.toFixed(1)} ${yB.toFixed(1)}`
            + ` C ${(cx - wP * 0.24).toFixed(1)} ${yB.toFixed(1)} ${xg.toFixed(1)} ${(yB - hP * 0.06).toFixed(1)} ${xg.toFixed(1)} ${(yP + hP * 0.54).toFixed(1)}`
            + ` C ${xg.toFixed(1)} ${(yP + hP * 0.26).toFixed(1)} ${(cx - wP * 0.34).toFixed(1)} ${(yP + hP * 0.06).toFixed(1)} ${cx.toFixed(1)} ${yP.toFixed(1)} Z`;

        g += `<path d="${d}" fill="${c1}" stroke="${p.ink}" stroke-width="2.5" stroke-linejoin="round"/>`;

        /* LA LIVRÉE, DÉCOUPÉE À LA FORME DE LA PELLE. Peindre les bandes plus
           larges en comptant sur le contour pour masquer le débord ne marche
           pas : un contour est un TRAIT, il ne rogne rien — la couleur
           dépassait de part et d'autre. On découpe donc pour de vrai.
           `clipPath` est du SVG 1.1 de base, rendu par resvg comme par le
           navigateur ; la parité aperçu / impression est vérifiée après. */
        const large = wP + 40, x0 = xg - 20;
        const bande = (y, ht) => `<rect x="${x0.toFixed(1)}" y="${y.toFixed(1)}" width="${large.toFixed(1)}" height="${ht.toFixed(1)}" fill="${c2}"/>`;
        let livree = '';
        if (motif === 'bandes') livree = bande(yP + hP * 0.30, hP * 0.13) + bande(yP + hP * 0.56, hP * 0.13);
        else if (motif === 'pointe') livree = bande(yB - hP * 0.30, hP * 0.30);
        else if (motif === 'diagonale')
          livree = `<path d="M ${x0.toFixed(1)} ${(yB + hP * 0.20).toFixed(1)} L ${(x0 + large).toFixed(1)} ${(yP + hP * 0.18).toFixed(1)} L ${(x0 + large).toFixed(1)} ${(yP + hP * 0.56).toFixed(1)} L ${x0.toFixed(1)} ${(yB + hP * 0.58).toFixed(1)} Z" fill="${c2}"/>`;
        else if (motif === 'chevron')
          livree = `<path d="M ${x0.toFixed(1)} ${(yP + hP * 0.46).toFixed(1)} L ${cx.toFixed(1)} ${(yP + hP * 0.24).toFixed(1)} L ${(x0 + large).toFixed(1)} ${(yP + hP * 0.46).toFixed(1)}`
            + ` L ${(x0 + large).toFixed(1)} ${(yP + hP * 0.64).toFixed(1)} L ${cx.toFixed(1)} ${(yP + hP * 0.42).toFixed(1)} L ${x0.toFixed(1)} ${(yP + hP * 0.64).toFixed(1)} Z" fill="${c2}"/>`;
        if (livree) g += `<clipPath id="snPelle"><path d="${d}"/></clipPath><g clip-path="url(#snPelle)">${livree}</g>`;
        g += `<path d="${d}" fill="none" stroke="${p.ink}" stroke-width="2.5" stroke-linejoin="round"/>`;

        /* Cotation : largeur de pelle en bas, longueur d'aviron à gauche. */
        const yc = yB + 34;
        g += `<line x1="${xg.toFixed(1)}" y1="${yc.toFixed(1)}" x2="${xd.toFixed(1)}" y2="${yc.toFixed(1)}" stroke="${p.muted}" stroke-width="1.2"/>`;
        for (const x of [xg, xd])
          g += `<line x1="${x.toFixed(1)}" y1="${(yc - 7).toFixed(1)}" x2="${x.toFixed(1)}" y2="${(yc + 7).toFixed(1)}" stroke="${p.muted}" stroke-width="1.2"/>`;
        g += `<rect x="${(cx - 46).toFixed(1)}" y="${(yc - 12).toFixed(1)}" width="92" height="24" fill="${p.bg}"/>`
          + T(cx, yc + 6, 16, p.muted, `${esc(String(data.largeur || '25').trim())} CM`, { f:'Oswald', w:700 })
          + coteV(xg - 62, yHaut, yB, `${fr(num(data.longueur) || 288)} CM`, p)
          + renvoi(xd, yP + hP * 0.14, xd + 46, up(PELLES[pelle]), 'PELLE', p);
        return g;
      },
      cotes: d => [[`${fr(num(d.longueur) || 288)} cm`, 'Aviron'],
        [esc(String(d.pelle || 'Hachoir').trim()), 'Pelle'],
        [esc(String(d.bateau || '').trim()) || '—', 'Bateau']],
      legende: d => `LIVRÉE ${up(cleFermee(d.couleur1, COULEURS, 'bleu'))} ET ${up(cleFermee(d.couleur2, COULEURS, 'blanc'))} · ${up(cleFermee(d.motif, { uni:1, bandes:1, diagonale:1, pointe:1, chevron:1 }, 'bandes'))}`,
    },
  };

  function stats(p, items, y) {
    const it = (items || []).filter(x => x && String(x[0] || '').trim());
    if (!it.length) return '';
    const x0 = 54, w = (PW - 2*x0) / it.length;
    let s = `<line x1="${x0}" y1="${y-34}" x2="${PW-x0}" y2="${y-34}" stroke="${p.line}" stroke-width="1.5"/>`;
    it.forEach((c, i) => {
      const cc = x0 + w*i + w/2;
      if (i) s += `<line x1="${(x0+w*i).toFixed(0)}" y1="${y-14}" x2="${(x0+w*i).toFixed(0)}" y2="${y+34}" stroke="${p.line}" stroke-width="1.5"/>`;
      s += T(cc, y+6, fit(c[0], w-24, 34, 0.56, 0, 14), p.ink, esc(c[0]), { f:'Oswald', w:700 })
        + T(cc, y+30, 12, p.muted, esc(up(c[1])), { w:600, ls:2.5 });
    });
    return s;
  }

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.calque;
    const modeId = Object.prototype.hasOwnProperty.call(OBJETS, String(data.mode || '').toLowerCase())
      ? String(data.mode).toLowerCase() : 'ski';
    const O = OBJETS[modeId];
    const cx = PW / 2;

    const titre = up(data.titre) || 'MON MATÉRIEL';
    const ts = fit(titre, 690, 74, 0.54, 2, 34);
    const kicker = up(data.kicker) || up(data.club) || up(O.label);
    const sous = [up(data.club), up(data.lieu)].filter(Boolean).join(' · ');

    /* Zone de dessin puis lignes de caractéristiques : la boîte de l'objet est
       la même pour tous, ce qui donne son unité à la gamme. */
    let corps = O.dessin(cx, 268, 444, data, p);
    corps += T(cx, 736, 11, p.muted, O.legende(data), { w:600, ls:2.6 });

    const l = [];
    for (let i = 1; i <= 5; i++) {
      const raw = String(data['l' + i] || '').trim(); if (!raw) continue;
      const [lab, v] = raw.split('|').map(x => (x || '').trim());
      if (lab && v) l.push([lab, v]);
    }
    if (l.length) {
      const y0 = 784, pas = Math.min(38, 152 / Math.max(1, l.length - 1 || 1));
      l.forEach((r, i) => {
        const y = y0 + i * pas;
        corps += T(MX, y, 13, p.muted, esc(up(r[0])), { w:600, ls:2.2, a:'start' })
          + T(PW - MX, y + 4, fit(r[1], 400, 22, 0.58, 0, 12), p.ink, esc(r[1]), { f:'Oswald', w:700, a:'end' });
        if (i < l.length - 1) corps += `<line x1="${MX}" y1="${(y + pas/2 - 5).toFixed(1)}" x2="${PW-MX}" y2="${(y + pas/2 - 5).toFixed(1)}" stroke="${p.line}" stroke-width="1.2"/>`;
      });
    }

    const barre = stats(p, O.cotes(data), 984);
    const bas = [esc(up(data.joueur)), esc(up(data.equipe))].filter(Boolean).join(' · ');
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
${T(cx, 84, 19, p.accent, esc(kicker), { w:700, ls:5 })}
${T(cx, 168, ts, p.ink, esc(titre), { f:'Oswald', w:700, ls:2 })}
${sous ? T(cx, 204, fit(sous, 660, 17, 0.66, 3.5, 11), p.muted, esc(sous), { w:600, ls:3.5 }) : ''}
${corps}
${barre}
${bas ? T(cx, 1044, fit(bas, 690, 18, 0.60, 1, 12), p.ink, bas, { f:'Oswald', w:700, ls:1 }) : ''}
</svg>`;
  }

  window.SNMtMateriel = { render, PALETTES, OBJETS };
})();
